import { Error404, SEO } from 'components/common'

export const Head = () => <SEO title="Page Not Found" />

// markup
const NotFoundPage = (): JSX.Element => {
  return (
    <>
      <Error404 />
    </>
  )
}

export default NotFoundPage
